const isEntitlementTECloud = (entitlement) =>
  entitlement && entitlement.application === 'SmartInsight'

export default isEntitlementTECloud
